import React, { memo } from 'react';
import {
  NavigationHeader,
  useHavenIdentity,
} from '@havenengineering/module-shared-haven-ui-layout';
import { analytics } from '../../../../helpers/gtm/analytics';

const Header = () => {
  const identity = useHavenIdentity({
    client: 'search',
  });

  return (
    <NavigationHeader analytics={(dataLayer) => analytics(dataLayer, false)} identity={identity} />
  );
};

export const DefaultHeader = memo(Header);
